// Lista de condiciones de la contraseña, con tilde/punto según se cumplan a
// medida que la persona escribe — compartida por ActivarCuentaPage y
// NuevaContrasenaPage (2026-09-13, pedido de Sue).
import type { JSX } from 'react';
import { Check, Circle } from 'lucide-react';
import { REGLAS_CONTRASENA } from './reglasContrasena';

export function ListaReglasContrasena({ password }: { password: string }): JSX.Element {
  return (
    <ul className="space-y-0.5">
      {REGLAS_CONTRASENA.map((regla) => {
        const cumple = regla.cumple(password);
        return (
          <li key={regla.id} className={`flex items-center gap-1.5 text-xs ${cumple ? 'text-hce-pine' : 'text-hce-muted'}`}>
            {cumple ? <Check className="w-3 h-3 shrink-0" aria-hidden="true" /> : <Circle className="w-3 h-3 shrink-0" aria-hidden="true" />}
            {regla.label}
          </li>
        );
      })}
    </ul>
  );
}
